function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.84062 11.4499C6.84062 8.67212 9.09245 6.42029 11.8702 6.42029C14.648 6.42029 16.8998 8.67212 16.8998 11.4499V11.4517C16.1741 11.7543 15.3777 11.9214 14.5423 11.9214C14.2376 11.9214 13.9381 11.8992 13.6453 11.8563C13.1026 13.6232 11.4577 14.9078 9.51282 14.9078C8.96856 14.9078 8.4478 14.8072 7.96812 14.6236C7.26322 13.7579 6.84062 12.6533 6.84062 11.4499Z",
  fill: "#A4A5A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9352 12.3145C16.0517 12.3145 17.0984 12.016 18 11.4945C17.9761 14.8594 15.2409 17.5799 11.8703 17.5799C9.10042 17.5799 6.75963 15.7427 6 13.2204C6.05251 13.251 6.10572 13.2806 6.1596 13.3091C6.85468 14.7658 8.34119 15.7723 10.0628 15.7723C12.1652 15.7723 13.917 14.2713 14.305 12.2825C14.5122 12.3036 14.7224 12.3145 14.9352 12.3145Z",
  fill: "#A4A5A8"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9.5,
  stroke: "#A4A5A8"
});

function SvgCarbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbon);
export default __webpack_public_path__ + "static/media/Carbon.b69e7e2a19c51c3bbf17db457e7f8470.svg";
export { ForwardRef as ReactComponent };